import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Error from './img/error@2x.png';
import Success from './img/verified@2x.png';
import { Overlay } from './../UIComponents';
import './Modal.scss';

export default function VerifingStatusModal({ visibility, status, onClose }) {
  const onContentClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div className={classnames('modal', { open: visibility })} >
      <Overlay onOverlayClick={onClose}>
        <a href="" className="verifying-status" onClick={onContentClick}>
          {
            status === 'success' ?
              <img src={Success} alt="presentation" width="55" /> :
              <img src={Error} alt="presentation" width="55" />
          }
          {
            status === 'success' ?
              <h4>Awesome its verified</h4> :
              <h4>Couldn&apos;t verify call forward</h4>
          }
        </a>
      </Overlay>
    </div>
  );
}

VerifingStatusModal.defaultProps = {
  onClose: () => {},
  visibility: false,
  status: 'error',
};

VerifingStatusModal.propTypes = {
  onClose: PropTypes.func,
  visibility: PropTypes.bool,
  status: PropTypes.oneOf(['success', 'error']),
};
